<template>
  <div>
    <p class="text-center"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></p>
    <p class="text-center pb-0 mb-0">Loading</p>
  </div>
</template>

<script>
export default {
  name: 'Loader'
};
</script>

<style lang="scss" scoped>
.fa {
  font-size: 3rem;
}
</style>
